import React, { useState } from "react";
import {
	AntdSteps,
	Body,
	Container,
	IconContainer,
	Inner,
	StepsContainer,
	TitleContainer,
} from "./styles.js";
import Step1Car from "./components/step1_car/Step1Car.js";
import Step2Quotation from "./components/step2_quotation/Step2Quotation.js";
import Step3Emission from "./components/step3_emission/Step3Emission.js";
import { Steps } from "antd";
import Number1Filled from "../../assets/images/number-one-solid.svg";
import Number2Grey from "../../assets/images/number-two.svg";
import Number2Filled from "../../assets/images/number-two-solid.svg";
import Number3Grey from "../../assets/images/number-three-icon.svg";
import Number3Filled from "../../assets/images/number-three-icon-selected.svg";
import CompletedStep from "../../assets/images/circle-check-regular.svg";
import { COLORS } from "../../components/layout/theme/index.js";
import { useFilter } from "../../contexts/FilterContext.js";
const { Step } = Steps;

const QuotationProcess = ({ isMobile }) => {
	const { step, setStep, step1Car, setStep1Car, step2Car, setStep2Car } =
		useFilter();
	const [step3Car, setStep3Car] = useState(0);

	const renderStep = () => {
		switch (step) {
			case 0:
				return (
					<Step1Car
						nextMainStep={handleStepSubmit}
						step1Car={step1Car}
						setStep1Car={setStep1Car}
						isMobile={isMobile}
					/>
				);
			case 1:
				return (
					<Step2Quotation
						nextMainStep={handleStepSubmit}
						step2Car={step2Car}
						setStep2Car={setStep2Car}
						isMobile={isMobile}
					/>
				);
			case 2:
				return (
					<Step3Emission
						nextMainStep={handleStepSubmit}
						step3Car={step3Car}
						setStep3Car={setStep3Car}
						isMobile={isMobile}
					/>
				);
			default:
				return null;
		}
	};

	const handleStepSubmit = (step) => {
		setStep(step);
	};

	return (
		<Inner isMobile={isMobile}>
			<Body>
				<StepsContainer isMobile={isMobile}>
					<AntdSteps current={step}>
						<Step
							icon={
								<IconContainer
									src={step === 0 ? Number1Filled : CompletedStep}
									alt="Number1"
									style={{ width: 30 }}
								/>
							}
							title={
								<Container>
									<TitleContainer color={step > 0 ? COLORS.Success : undefined}>
										Info vehículo
									</TitleContainer>
								</Container>
							}
						/>
						<Step
							icon={
								<IconContainer
									src={
										step === 1
											? Number2Filled
											: step < 1
											? Number2Grey
											: CompletedStep
									}
									alt="Number2"
									style={{ width: 30 }}
								/>
							}
							title={
								<Container>
									<TitleContainer color={step > 1 ? COLORS.Success : undefined}>
										Cotizar seguro
									</TitleContainer>
								</Container>
							}
						/>
						<Step
							icon={
								<IconContainer
									src={step === 2 ? Number3Filled : Number3Grey}
									alt="Number3"
									style={{ width: 30 }}
								/>
							}
							title={
								<Container>
									<TitleContainer>Emisión y pago</TitleContainer>
								</Container>
							}
						/>
					</AntdSteps>
				</StepsContainer>
				{renderStep()}
			</Body>
		</Inner>
	);
};

export default QuotationProcess;
